import React from 'react';
import StartQuiz from './screens/StartQuiz';


function App() {
  return (
    <>
      <StartQuiz/>
    </>
  );
}

export default App;
